var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.running)?_c('canvas',{ref:"canvas",staticClass:"confetti-rain",attrs:{"aria-hidden":"true"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }